import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  CatalogsIcon,
  RelatedTablesDefinitionIcon,
  UserTableDefinitionIcon,
  SystemTableDefinitionIcon,
  UserMenusIcon,
  SpecialProcessDefinitionIcon,
} from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";

const ExtensibilityScreenSelector = ({ history }) => {

  const data = [
    {
      name: getLocalizedString("catalogs"),
      icon: <CatalogsIcon />,
      path: paths.catalogs,
    },
    {
      name: getLocalizedString("relatedTablesDefinition"),
      icon: <RelatedTablesDefinitionIcon />,
      path: paths.relatedTablesDefinition,
    },
    {
      name: getLocalizedString("specialProcessDefinition"),
      icon: <SpecialProcessDefinitionIcon />,
      path: paths.specialProcessDefinition,
      onClick: () => {
        history.push({
          pathname: paths.specialProcessDefinition,
          state: {
            from: paths.extensibilityScreenSelector,
          },
        });
      }
    },
    {
      name: getLocalizedString("userTablesDefinition"),
      icon: <UserTableDefinitionIcon />,
      path: paths.userTablesDefinition,
    },
    {
      name: getLocalizedString("systemTablesDefinition"),
      icon: <SystemTableDefinitionIcon />,
      path: paths.systemTablesDefinition,
    },
    {
      name: getLocalizedString("userMenus"),
      icon: <UserMenusIcon />,
      path: paths.userMenus,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("extensibilityScreenSelector")}
      data={data}
    />
  );
}

export default ExtensibilityScreenSelector;
